import { styled, Theme } from '@core-ui/react-stitch';

type StickyProps = {
  totalStickyElementHeight: number;
  theme?: Theme;
};

const Scrollable = styled.div(
  ({ theme, totalStickyElementHeight }: StickyProps) => ({
    top: `${totalStickyElementHeight}px`,
    width: '100%',
    background: theme?.color?.wh,
    paddingRight: '.5rem',
    paddingLeft: '.5rem',
    height: `calc(100vh - ${totalStickyElementHeight}px)`,
    overflowY: 'auto',
    overflowX: 'hidden',
    '&::-webkit-scrollbar': {
      width: '.25rem',
      backgroundColor: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme?.color?.g3,
    },
    position: 'sticky',
    zIndex: 100,
  })
);

export default Scrollable;
